export default function () {
    return {
        KEYS: {
            POWER_BI: 'POWER_BI'
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/company/integrationTokenType/index.js